// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FhZ6l","title":"styles_title__2p6Oc"};